import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

export default class {

    constructor(options) {

        // OPTIONS
        this.defaults = {
            $el: undefined
        }

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'history_timeline';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// vars
		this.$win = $(window);

		this.ids = [];

		// set events
		this.events = [];
		this.$images = [];
		this.$el.find( '.event' ).each( (i, el) => {
			this.events[i] = {
				$el: $(el),
				$content : $(el).find( '.content' ),
				$img: undefined,
				$text: undefined
			}
		} );

		// set images and texts
		this.$first = this.events[0].$el;
		let i = this.events.length;
		while( i-- ){
			this.events[i].$img 	= this.$first.find( '.image .img-wrapper' ).eq(i);
			this.events[i].$text 	= this.$first.find( '.content .vertical-center' ).eq(i);
			// set text to 0 opacity
			if ( i > 0 ){
				this.events[i].$text.css( 'opacity', 0 )
			}
		}

		this.$bg = this.$first.find( '.bg' );
		this.$bg.css( 'opacity', 0 );

		// init!!!!
		this.init( true );

		setTimeout( ()=> this.$el.addClass( 'ready' ), 117 );

    }

	init( b ){		
		this.initScrollTrigger(b);
	}

	initScrollTrigger(b){
		if ( b ){

			let end = () => {return this.$el.height() - this.$win.height()},
				i, 
				t = this.events.length,
				$first_two_years_to_change = this.$el.find( '.change-first-two-years' );

			// lock first slide where all images and text are located
			ScrollTrigger.create({
				trigger: this.$first,
				pin: true,
				pinSpacing: false,
				end: '+=' + end(),
				scrub: false,
				//markers: true,
				id: this.getID()
			});

			for( i=1; i<t; i++ ){

				gsap.fromTo(

					// image fade animation animation
					this.events[i].$img, 

					{ opacity:0 },
					
					{
						opacity: 1,
						ease: "none",

						scrollTrigger: {

							trigger: this.events[i].$content,

							start: 'top center',
							end: 'center center',
							scrub: true,
							//markers: true,
							id: this.getID(),

							onUpdate: self => {
								//console.log("progress", self.progress)
								
								let $e = $(self.trigger).parents( '.event' ), 
								j = $e.attr( 'data-index' );
								

								// set bg to blue (fade in) when entering the dialog event
								if ( $e.hasClass( 'dialog-logo-event' ) ){
									gsap.set( this.$bg, {opacity: Math.min( 1, self.progress*1.7) });
								}
								
								// set bg to white (fade out) when leaving the dialog event
								$e = this.events[j-1].$el;
								if ( $e.hasClass( 'dialog-logo-event' ) ){
									gsap.set( this.$bg, {opacity: Math.max(0, 1-self.progress*2)});
								}

								// text current text fade in
								gsap.set( this.events[j].$text, {opacity: self.progress});
								// text preceden text fade out
								gsap.set( this.events[j-1].$text, {opacity: Math.max(0, 1-self.progress*2)});
								
							}
						}
					}	
				)
			}

			// change first two years when switch ...
			if ( $first_two_years_to_change.length > 1 ){
				for( i=1; i<$first_two_years_to_change.length; i++ ){
					gsap.to(
						this.$first.find( '.first-year-container' ),
						{
							y: '-' + (i*100) + '%',
							ease: "none",
							scrollTrigger: {
								trigger: $first_two_years_to_change[i],
								start: 'top bottom',
								end: 'center center',
								scrub: true,
								id: this.getID()								
							}
						}	
					)					
				}
			}

		}
		else{
			this.destroyScrollTriggers();
		}
	}

	//--------------------- UTILS ----------------------//
	getID(){
		const id = 'id_' + this.namespace + '_' + this.ids.length;
		this.ids.push( id );
		return id;
	}

	killById( id ){
		if ( ScrollTrigger.getById( id ) ){
			ScrollTrigger.getById( id ).kill();
		}
	}

	destroyScrollTriggers(){
      	if ( this.ids.length ){
      		let i = this.ids.length;
      		while( i-- ){
      			this.killById( this.ids[i] );
      		}
      		this.ids = [];
      	}
	}

    destroy(){
		this.init( false );
		this.$el.removeData();
    }

}
